import { Component, OnInit, Input, ElementRef } from "@angular/core";
import { Platform } from "@ionic/angular";
//Services
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { RouterService } from "src/app/services/router/router.service";
import { TagsService } from "src/app/services/tags/tags.service";

@Component({
  selector: "app-list-content",
  templateUrl: "./list-content.component.html",
  styleUrls: ["./list-content.component.scss"],
})
export class ListContentComponent implements OnInit {
  @Input() categories: [];
  slidesFiltersPerView: number = 3.1;
  slidesContentPerView: number = 1.5;

  optionSelected = "Noticias";

  categories_app: any;
  categories_app_active: any = [];
  slideOpts = {};
  slideButtonsOpts = {};
  isActive;

  constructor(
    private myElement: ElementRef,
    private languageService: LanguagesService,
    public platform: Platform,
    private routerService: RouterService,
    private tagsService: TagsService
  ) {}

  color(i){
    switch (i) {
      case 0:
        return 'colorPrimary'
      case 1:
        return 'colorSecondary'
      case 2:
        return 'colorTertiary'
      case 3:
        return 'colorQuaternary'
      default:
        return 'colorPrimary'
    }
  }

  async ngOnInit() {
   // this.tagsService.setEventTag("content_page", "content_screen_viewed");
    if (this.platform.is("desktop")) {
      this.slidesFiltersPerView = 6;
      this.slidesContentPerView = 4;
    }

    this.categories.map((category:any) => {
      if(category.subcategories.length > 0){
        category.subcategories.map((x:any, index: number) => {
          x.backColor = this.color(index)
        })
      }
    })

    this.slideOpts = {
      pagination: false,
      initialSlide: 0,
      slidesPerView: this.slidesContentPerView,
      speed: 400,
    };

    this.slideButtonsOpts = {
      pagination: false,
      slidesPerView: this.slidesFiltersPerView,
      freeMode: true,
      coverflowEffect: {
        rotate: 50,
        stretch: 2,
        depth: 100,
        modifier: 0,
        slideShadows: true,
      },
    };

    this.categories_app = this.languageService.textsIU.category_content;

    this.categories_app.forEach((element: any) => {
      if (element.active) {
        this.categories_app_active.push(element);
      }
    });
  }

  scroll(div: any) {
    const el = document.getElementById(div);
    el.scrollIntoView({ behavior: "smooth" });
  }

  onClick(event: any) {
    this.optionSelected = event;
  }

  get getTextsIUContent() {
    return this.languageService.textsIU.page_content;
  }

  get getTextsIUContentTitle() {
    return this.languageService.textsIU.page_contact_title_ex.title;
  }

  get getTextsIUContentSubTitle() {
    return this.languageService.textsIU.page_contact_subtitle_ex.title;
  }

  goTo(route) {
    if( this.platform.is("desktop") &&  (route == "challenges" || route == "exhibitions" || route == "invoices")){
      route = "app/"+route;
    }
    this.routerService.redirect(route);
  }
  
  setTags(data: any) {
    this.tagsService.setEventTag(
      "content_page",
      "content_category_clicked",
      false,
      true,
      null,
      data.Title
    );
  }
}
